import { EntityKeyByReference, Note } from '@card-software/library';
import { OutgoingReceiptLineBase } from '../receipt-line-base';
import { AuditTrail } from '@card-software/nexus-models';
import { Translation } from '../translation';
import { StatusHistoryEntry } from '../inventory/goods-receipt';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ReceiptLineBase } from '../receipt-line-base';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { StorageLocation } from '../storage-location';

export enum StatusDispatchRequest {
  Pending = 0,
  Processing = 1,
  Completed = 2,
  Cancelled = 3,
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface DispatchRequestLine extends OutgoingReceiptLineBase {}

export interface DispatchRequest extends AuditTrail {
  /** Descends from an Administrative purchase order (#5942); only role holders can see it, the API enforces. */
  isAdministrative?: boolean;
  id?: string;
  number?: string;
  initiator: EntityKeyByReference;
  status: StatusDispatchRequest;
  locationCode: string;
  locationName?: Translation;
  departmentReference?: string;
  entries: DispatchRequestLine[];
  receiverUserName: string;
  notes?: Note[];
  statusHistory?: StatusHistoryEntry<StatusDispatchRequest>[];
  dueDate: string;

  // Supply Request origin info (populated when dispatch was created from a supply request)
  supplyRequestNumber?: string;
  supplyRequestCreatedBy?: string;
  supplyRequestDepartmentName?: Translation;
}
